// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ci-b";
export var colorBlue = "_ci-8";
export var colorDot = "_ci-0";
export var colorDotLarge = "_ci-2";
export var colorDotSmall = "_ci-1";
export var colorGreen = "_ci-7";
export var colorGrey = "_ci-3";
export var colorOrange = "_ci-5";
export var colorPink = "_ci-a";
export var colorPurple = "_ci-9";
export var colorRed = "_ci-4";
export var colorYellow = "_ci-6";